angular
  .module('ui-ng-polymer', [])
  .directive('ngply', function plyng($parse) {

    const START_OF_ATTR_NAME = `plyBindX`.length;
    const START_OF_IN_ATTR_NAME = `plyInBindX`.length;
    const KEBAB_JOINTS = /-([a-z])/g;
    const CAMEL_JOINTS = /([a-z])([A-Z])/g;
    const kebabToCamel = function (attrName) {
      return attrName.replace(KEBAB_JOINTS, (_1, varName) => varName.toUpperCase());
    };
    const camelToKebab = function (attrName) {
      return attrName.replace(CAMEL_JOINTS, (_1, lowercaseLetter, uppercaseLetter) => `${lowercaseLetter}-${uppercaseLetter}`)
        .toLowerCase();
    };

    return {
      restrict: 'A',
      scope: false,
      compile: function (element, attrs) {

        const keyAttrs = _.map(_.keys(attrs), (key) => key.trim());
        const plyAttrs = _.filter(keyAttrs, (key) => {
          return key.startsWith(`plyBind`) && !key.startsWith(`plyBind*`);
        });
        const plyInAttrs = _.filter(keyAttrs, (key) => {
          return key.startsWith(`plyInBind`);
        });
        const plyEventAttrs = _.filter(keyAttrs, (key) => {
          return key.startsWith(`plyEvent`);
        });

        return {
          pre: function prelinkPLGNG($scope, $element, $attrs) {

            const elem = $element[0];
            const eventListeners = {};

            // angular -> polymer (phy-bind-<property>)
            _.each(plyAttrs, function angularMutationsToPolymer(plyAttrKey) {
              $scope.$watch($attrs[plyAttrKey], (val) => {

                const attributeRest = plyAttrKey
                  .slice(START_OF_ATTR_NAME);

                const firstLetter = plyAttrKey
                  .slice(START_OF_ATTR_NAME - 1, START_OF_ATTR_NAME)
                  .toLowerCase();

                elem[firstLetter + attributeRest] = val;

              });
            });

            // angular -> polymer (phy-in-bind-<property>)
            _.each(plyInAttrs, function angularMutationsToPolymer(plyAttrKey) {
              $scope.$watch($attrs[plyAttrKey], (val) => {

                const attributeRest = plyAttrKey
                  .slice(START_OF_IN_ATTR_NAME);

                const firstLetter = plyAttrKey
                  .slice(START_OF_IN_ATTR_NAME - 1, START_OF_IN_ATTR_NAME)
                  .toLowerCase();

                elem[firstLetter + attributeRest] = val;

              });
            });

            // polymer -> angular
            const observer = new MutationObserver(function polymerMutationsToAngular(mutations) {
              $scope.$applyAsync(function handleMutationUpdateToAngular() {

                let attributeValue = undefined;
                let attributeVariable = '';
                let didAnyUpdate = false;

                mutations.forEach(function processMutation(mutation) {

                  const camelAttr = kebabToCamel(mutation.attributeName);
                  const val = elem[camelAttr];
                  const attrInAngular = 'plyBind' + _.capitalize(camelAttr);

                  if (attrInAngular === 'plyBind*') {
                    return;
                  }
                  else if (!_.includes(plyAttrs, attrInAngular)) {
                    return;
                  }

                  const propertyLookup = $attrs[attrInAngular];

                  _.set($scope, propertyLookup, val);
                  attributeVariable = mutation.attributeName;
                  attributeValue = val;
                  didAnyUpdate = true;

                });

                if (!didAnyUpdate) {
                  return;
                }

                if (!!$attrs['plyBind*']) {
                  $parse($attrs['plyBind*'])($scope, {
                    attributeVariable,
                    attributeValue
                  });
                }

              });
            });

            observer.observe(elem, {
              attributes: true
            });

            // polymer(event) -> angular(function)
            _.each(plyEventAttrs, function angularMutationsToPolymer(plyEventAttrKey) {

              const polymerEventName = camelToKebab(plyEventAttrKey.replace('plyEvent', ''));

              eventListeners[polymerEventName] = ($event) => {
                $scope.$applyAsync(function handleEventUpdateToAngular() {
                  if (!!$attrs[plyEventAttrKey]) {
                    try {
                      const ifAccessingFailed = $event.target;
                    }
                    catch (err) {
                      $event = {
                        target: $event.__target,
                        detail: $event.detail
                      };
                    }
                    $parse($attrs[plyEventAttrKey])($scope, {
                      $event
                    });
                  }
                });
              };

              elem.addEventListener(polymerEventName, eventListeners[polymerEventName]);

            });

            $scope.$on('$destroy', () => {
              observer.disconnect.bind(observer);
              _.each(plyEventAttrs, (plyEventAttrKey) => {
                const polymerEventName = camelToKebab(plyEventAttrKey.replace('plyEvent', ''));
                elem.removeEventListener(polymerEventName, eventListeners[polymerEventName]);
              });
            });

          }
        };
      }
    };
  });



// WEBPACK FOOTER //
// core.es.js